import React, { useState } from 'react';
import CustomModal from '../CustomModal';
import { Divider, Input } from 'antd';
import { getFileUrl, getUploadUrl, uploadFileToS3 } from '../../redux/actions/upload';
import { sentGroupMessage, sentMessage } from '../../redux/actions/message';
import { errorToast } from '../../utils/toast';
import { messageType } from '../../constants';
import { defaultStyles, FileIcon } from 'react-file-icon';

const FileWithCaption = ({ open, onCancel, userId, fileData, isGroup, groupId, members = [] }) => {
    const [caption, setCaption] = useState('');
    const [isSending, setIsSending] = useState(false);

    const handleSend = async () => {
        if (!fileData) return;

        setIsSending(true);

        try {

            let fileLink = null;

            if (isGroup) {
                for (const member of members) {
                    const uploadUrl = await getUploadUrl(fileData.file, 'chats', member.contact_id, fileData.display_name);
                    await uploadFileToS3(uploadUrl, fileData.file, fileData.file.type);
                    fileLink = getFileUrl('chats', member.contact_id, fileData.display_name);
                }
            } else {
                const uploadUrl = await getUploadUrl(fileData.file, 'chats', userId, fileData.display_name);
                await uploadFileToS3(uploadUrl, fileData.file, fileData.file.type);
                fileLink = getFileUrl('chats', userId, fileData.display_name);
            }

            const body = {
                contact_id: userId,
                type: fileData.type,
                text: caption || null,
                attachment: {
                    name: fileData.display_name,
                    type: fileData.file.type,
                    link: fileLink,
                    filename: fileData.file.name
                },
            };

            isGroup ? await sentGroupMessage(groupId, body) : await sentMessage(body);
            setCaption('');
            onCancel();
        } catch (err) {
            console.error('Error sending file with caption:', err);
            errorToast('Failed to send message');
        } finally {
            setIsSending(false);
        }
    };

    const renderFilePreview = () => {
        if (!fileData) return null;
        const file = fileData.file;
        const ext = file?.name?.split('.').pop()?.toLowerCase();
        const style = defaultStyles[ext] || {};

        if (fileData?.type === messageType.IMAGE) {
            return <img src={URL.createObjectURL(file)} alt="Preview" style={{ width: '100%' }} />;
        } else if (fileData?.type === messageType.VIDEO) {
            return <video src={URL.createObjectURL(file)} controls style={{ width: '100%' }} />;
        } else if (fileData?.type === messageType.DOCUMENT) {
            return <div className="doc-preview-card">
                <div className="file-icon">
                    <FileIcon extension={ext} {...style} />
                </div>
                <div className="container">
                    <div className="title">
                        {file.name}
                    </div>
                </div>
            </div>
        }
    };

    return (
        <CustomModal
            title="Send File with Caption"
            open={open}
            onCancel={onCancel}
            okText="Send"
            onOk={handleSend}
            confirmLoading={isSending}
        >
            <div className="file-preview">
                {renderFilePreview()}
            </div>

            <Divider />
            <Input.TextArea
                placeholder="Enter caption (optional)"
                rows={3}
                value={caption}
                onChange={(e) => setCaption(e.target.value)}
            />
        </CustomModal>
    );
};

export default FileWithCaption;
